import { chartBackgroundColor } from "./globals";
import Highcharts from "highcharts";
import "highcharts/highcharts-more";
import "highcharts/modules/solid-gauge";

// Level chart colors and configuration
const levelChartColor = "#35778B"; // Original CMMC level chart color (teal)
const paneColor = "#E8ECF5";

document.addEventListener("turbo:load", () => {
  const charts: NodeListOf<HTMLElement> = document.querySelectorAll(
    "[data-chart='level_chart']",
  );

  if (charts) {
    Array.from(charts).forEach((chart) => {
      const title = chart.dataset.title || "";
      const score = parseInt(chart.dataset.score || "0", 10);
      const max = parseInt(chart.dataset.max || "100", 10);

      const percentage = (score / max) * 100;

      Highcharts.chart({
        chart: {
          renderTo: chart,
          backgroundColor: chartBackgroundColor,
          type: "solidgauge",
          marginTop: 0,
        },
        title: {
          text: title,
          y: 90,
          style: {
            color: levelChartColor,
            fontSize: ".95em",
            fontWeight: "bold",
          },
        },
        yAxis: {
          lineWidth: 0,
          labels: {
            enabled: false,
          },
          minorTicks: false,
          min: 0,
          max: 100,
          tickWidth: 0,
          title: {
            text: `<span class="text-3xl font-bold">${score}</span><br/><span style="font-size: 14px">Out of ${max}</span>`,
            y: 80,
          },
        },
        tooltip: {
          enabled: false,
        },
        pane: {
          borderRadius: 0,
          center: ["50%", "50%"],
          startAngle: 0,
          endAngle: 360,
          size: "85%",
          background: [
            {
              backgroundColor: paneColor,
              borderWidth: 0,
              innerRadius: "85%",
              outerRadius: "100%",
              shape: "circle",
            },
          ],
        },
        plotOptions: {
          solidgauge: {
            innerRadius: "85%",
            animation: false,
          },
        },
        series: [
          {
            type: "solidgauge",
            data: [percentage],
            colorByPoint: false,
            color: levelChartColor,
            dataLabels: {
              verticalAlign: "top",
              y: -40,
              x: 17,
              borderWidth: 0,
              formatter: () => null,
              style: {
                color: levelChartColor,
                fontSize: "5em",
                fontWeight: "bold",
                textAnchor: "middle",
              },
            },
          },
        ],
      });
    });
  }
});
